import React from 'react';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';

// ============================================
// 🏗️ NEW CONCEPT: SYSTEM CORE
// Pure, Technical, Developer-First
// ============================================

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;700&display=swap');
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    cursor: default; /* 커스텀 커서 느낌을 위해 기본 커서 통일 */
  }

  body {
    font-family: 'Inter', 'Pretendard', sans-serif;
    background-color: #030405; /* Deep Void Black */
    color: #E2E8F0;
    line-height: 1.6;
    overflow-x: hidden;
  }

  /* 스크롤바 커스텀 */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: #030405;
  }
  ::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #475569;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    letter-spacing: -0.03em;
  }

  a, button {
    cursor: pointer;
  }
  
  /* 모노스페이스 폰트 클래스 */
  .mono {
    font-family: 'JetBrains Mono', monospace;
  }
`;

const theme = {
  colors: {
    bg: '#030405',
    surface: '#0F1115',
    surfaceLight: '#1A1D24',
    border: '#272A32',
    primary: '#38BDF8', // Sky Blue
    accent: '#818CF8', // Indigo
    success: '#34D399',
    text: '#F1F5F9',
    textDim: '#94A3B8',
    textDark: '#475569',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  },
  transitions: {
    default: '0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  }
};

const AppContainer = styled.div`
  min-height: 100vh;
  position: relative;
  
  /* 미세한 그리드 배경 */
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  
  &::after {
    content: '';
    position: fixed;
    top: 0; 
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 50% 0%, rgba(56, 189, 248, 0.05), transparent 60%);
    pointer-events: none;
    z-index: 0;
  }
`;

const MainContent = styled.main`
  position: relative;
  z-index: 1;
  padding-top: 80px;
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Toaster 
        position="bottom-center"
        toastOptions={{
          style: {
            background: '#0D1117',
            color: '#E2E8F0',
            border: '1px solid rgba(56, 189, 248, 0.2)',
            backdropFilter: 'blur(10px)',
          },
        }} 
      />
      <AppContainer>
        <Header />
        <MainContent>
          <Hero />
          <About />
          <Skills />
          <Projects />
          <Experience />
          <Contact />
        </MainContent>
        <Footer />
      </AppContainer>
    </ThemeProvider>
  );
}

export default App;
